import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { IfPermission } from '@folio/stripes/core';
import { ListPage, ListInformationPage, CreateListPage, EditListPage } from './pages';
export var queryClient = new QueryClient();
export var ListsApp = function (props) {
    var path = props.match.path;
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(Switch, null,
            React.createElement(Route, { path: path, exact: true, render: function () { return (React.createElement(IfPermission, { perm: "lists.item.get" /* USER_PERMS.ReadList */ },
                    React.createElement(ListPage, null))); } }),
            React.createElement(Route, { path: "".concat(path, "/list/:id"), exact: true, render: function () { return (React.createElement(IfPermission, { perm: "lists.item.get" /* USER_PERMS.ReadList */ },
                    React.createElement(ListInformationPage, null))); } }),
            React.createElement(Route, { path: "".concat(path, "/list/:id/edit"), exact: true, render: function () { return (React.createElement(IfPermission, { perm: "lists.item.update" /* USER_PERMS.UpdateList */ },
                    React.createElement(EditListPage, null))); } }),
            React.createElement(Route, { path: "".concat(path, "/new"), exact: true, render: function () { return (React.createElement(IfPermission, { perm: "lists.collection.post" /* USER_PERMS.CreateList */ },
                    React.createElement(CreateListPage, null))); } }))));
};
export default ListsApp;
